import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {PearlHarbor} from "../PearlHarbor";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class PearlHarborIdleNormalPresentation implements FlowStatePresentation {

    private skip(flowStateController: FlowStateController): void {
        flowStateController.finish();
    }

    public start(flowStateController: FlowStateController) {
        flowStateController.setSkipCallback(() => this.skip(flowStateController));
        PearlHarbor.scatterAnimation.onSpinStop();
        if (PearlHarbor.model.data.nextMode === GameMode.NORMAL && !PearlHarbor.autoPlayPlugin.isAutoplayRound) {
            PearlHarbor.backgroundElements.startIdle();
            PearlHarbor.foregroundElements.enableButton(true);
        }
        flowStateController.finish();
    }
}